const EventEmitter = require('eventemitter3');

const StandardStrike = require('../StandardStrike');
const BattleCalc = require('../../BattleCalc');
const BattleConfig = require('../../../constants/BattleConfig');
const KnockbackEvent = require('../../events/KnockbackEvent');
const { logError } = require('../../logger');

const ChainPull = function(battleState) {
  this.handle = 'chain_pull';
  this.physical = true;
  this.bow = true;
  this.harm = true;

  this.standardStrike = new StandardStrike(this, battleState);

  this.eventEmitter = new EventEmitter();

  this.isLegal = function(actor, victim) {
    return victim.unit && actor.equipment.off_hand && actor.equipment.off_hand.type==='bow';
  };

  this.execute = function(actor, victim) {
    if (!actor || !actor.inPlay || !victim || (victim.unit&&!victim.inPlay)) {
      return { success: false };
    }

    const ability = BattleCalc.getEquippedAbility(actor, this.handle);

    setTimeout(() => {
      try {
        if (!actor || !actor.inPlay || !victim || (victim.unit&&!victim.inPlay)) {
          return;
        }

        const result = this.standardStrike.execute(
          actor,
          victim,
          ability.damage,
          true,
        );
        result.abilityHandle = this.handle;
        result.actorId = actor.uid;
        result.victimId = victim.uid;
        result.allPieces = battleState.allPieces;

        if (result.success && !victim.dead) {
          setTimeout(()=> {
            new KnockbackEvent(battleState, victim).execute(battleState.getTileAtCoords(victim.x,victim.y), getDestinationTile());
          }, BattleCalc.getCooldown(actor)*0.38*1000);
        }

        this.eventEmitter.emit('result', result);
      } catch (err) {
        logError(err, {
          module: 'ChainPull',
          func: 'execute',
          actor,
          victim,
        });
      }
    }, BattleCalc.projectileTime(BattleConfig.ARROW_SPEED, actor, victim));

    function getDestinationTile() {
      var candidates = findCandidateDestinationTiles();

      if (!candidates) {
        return battleState.getTileAtCoords(victim.x, victim.y);
      }

      return selectMiddleCandidate(candidates); // candidates[ Math.floor(Math.random()*candidates.length) ]; // ;
    }

    function findCandidateDestinationTiles() {
      var actorDist;
      var victimDist;
      var distBetweenUnits = BattleCalc.boardDistance(actor, victim);

      var potency = ability.potency;
      if (potency >= distBetweenUnits) {
        potency = distBetweenUnits - 1;
      }

      var candidates = [];

      for (; potency > 0; --potency) {
        for (var tileId in battleState.allTiles)	{
          var tile = battleState.allTiles[ tileId ];

          actorDist = BattleCalc.boardDistance(actor, tile);
          victimDist = BattleCalc.boardDistance(victim, tile);

          if (!tile.occupied && victimDist===potency && BattleCalc.pieceIsBetweenPair(tile,[actor,victim])) {
            candidates.push(tile);
          }
        }

        if (candidates.length > 0) {
          return candidates;
        }
      }

      return null;
    }

    function selectMiddleCandidate(candidates) {
      var best = candidates[0];
      var xDist = Math.abs(actor.x - victim.x);
      var yDist = Math.abs(actor.y - victim.y);
      var xAvg = (actor.x + victim.x) / 2;
      var yAvg = (actor.y + victim.y) / 2;

      for (var i = 0; i < candidates.length; ++i)	{
        var tile = candidates[ i ];
        if (xDist>yDist && Math.abs(tile.y-yAvg)<Math.abs(best.y-yAvg)) {
					 best = tile;
        } else if (yDist>xDist && Math.abs(tile.x-xAvg)<Math.abs(best.x-xAvg))	{
          best = tile;
        }
      }

      return best;
    }
  };
};
module.exports = ChainPull;
